import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle="Сторінку не знайдено."
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          На головну
        </Button>
      }
    />
  );
};

export default NotFoundPage;
